import BasePolicy from '@/policies/BasePolicy.js';

export default class TermSchedulePolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view all term schedules';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    view(user, termSchedule) {
        const permission = 'view a term schedule';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(termSchedule);
        }

        return user.hasPermissionTo(permission);
    }

    create(user) {
        const permission = 'create a term schedule';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }

    update(user, termSchedule) {
        const permission = 'edit a term schedule';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(termSchedule);
        }

        return user.hasPermissionTo(permission);
    }

    delete(user) {
        const permission = 'delete a term schedule';

        return user.hasPermissionTo(permission);
    }
}
